import React, { useCallback, useEffect, useMemo, useState } from "react";
import { getItem, setItem } from "Common/localStorage/utils";
import { Divider } from "Components/Divider";
import includes from "lodash/includes";
import isString from "lodash/isString";
import values from "lodash/values";
import { TAB, localStorageSettingsKey } from "./constants";
import locale from "./downSidePanel.locale";
import Presentation from "./presentation";
import TasksLogs from "./tasksLogs";
import Timeline from "./timeline";
import styles from "./downSidePanel.module.css";
import ButtonGroup from "Components/buttonGroup";
function DownSidePanel({ style, canViewTasksLogs, statisticData, parentInProgress, disabledTabs }) {
    const tabs = useMemo(() => {
        const res = [];
        if (!includes(disabledTabs, TAB.PRESENTATION)) {
            res.push({
                icon: "icon-manual-gearbox",
                hint: locale.PRESENTATION,
                key: TAB.PRESENTATION,
                text: locale.PRESENTATION,
                disabled: false
            });
        }
        if (!includes(disabledTabs, TAB.TIMELINE)) {
            res.push({
                icon: "icon-map-pins",
                hint: locale.TIMELINE,
                key: TAB.TIMELINE,
                text: locale.TIMELINE,
                disabled: false
            });
        }
        if (canViewTasksLogs) {
            res.push({
                icon: "icon-history",
                hint: locale.TASKS_LOGS,
                key: TAB.TASKS_LOGS,
                text: locale.TASKS_LOGS,
                disabled: includes(disabledTabs, TAB.TASKS_LOGS)
            });
        }
        return res;
    }, [disabledTabs, canViewTasksLogs]);
    const [settings, setSettings] = useState();
    useEffect(() => {
        var _a;
        const localStorageData = getItem(localStorageSettingsKey);
        const availableTabs = tabs.filter(tab => !tab.disabled);
        const savedViewType = localStorageData === null || localStorageData === void 0 ? void 0 : localStorageData.viewType;
        const isValidSavedType = isString(savedViewType) &&
            includes(values(TAB), savedViewType) &&
            availableTabs.some(tab => tab.key === savedViewType);
        const viewType = isValidSavedType ? savedViewType : (_a = availableTabs[0]) === null || _a === void 0 ? void 0 : _a.key;
        setSettings({ viewType });
    }, [tabs]);
    useEffect(() => {
        setItem(localStorageSettingsKey, settings);
    }, [settings]);
    const handleItemClick = useCallback((itemData) => {
        setSettings(prev => ((prev === null || prev === void 0 ? void 0 : prev.viewType) !== itemData.key ? { viewType: itemData.key } : prev));
    }, []);
    const renderContent = () => {
        switch (settings === null || settings === void 0 ? void 0 : settings.viewType) {
            case "timeline":
                return React.createElement(Timeline, { data: statisticData });
            case "presentation":
                return React.createElement(Presentation, { data: statisticData });
            case "tasksLogs":
                return React.createElement(TasksLogs, { parentInProgress: parentInProgress });
            default:
                return null;
        }
    };
    const handlePreventDefault = (e) => {
        e.preventDefault();
    };
    return (React.createElement("div", { style: style, className: styles.container, onContextMenu: handlePreventDefault },
        React.createElement("div", { className: styles["tabs-container"] },
            React.createElement("div", { className: styles.tabs },
                React.createElement(ButtonGroup, { backgroundColor: "action-light-panel-bg", color: "action-light-panel-color", iColor: "action-light-panel-color", hoverBackground: "action-light-panel-hover-bg", hoverColor: "action-light-panel-hover-color", hoverIColor: "action-light-panel-hover-color", activeBackground: "action-light-panel-active-bg", activeColor: "action-light-panel-active-color", activeIColor: "action-light-panel-active-color", selectedBackground: "action-light-panel-selected-bg", selectedColor: "action-light-panel-selected-color", selectedIColor: "action-light-panel-selected-color", className: styles.tab, fontSize: 14, iconFontSize: 18, items: tabs, selectedItemKey: settings === null || settings === void 0 ? void 0 : settings.viewType, onItemClick: handleItemClick, height: 28 })),
            React.createElement(Divider, null)),
        React.createElement("div", { className: styles.content }, renderContent())));
}
export default DownSidePanel;
